import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

//ReactDOM.render(<App />, document.getElementById('root'));

const appRoot = document.getElementById('root');

appRoot.setAttribute('notranslate', true);

ReactDOM.render(<App />, appRoot);
